var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Report',{attrs:{"filters":_vm.filters,"header":_vm.header,"module":"Estoque","name":"Produtos","urlGet":"/api/v1/stock/report/product"}})}
var staticRenderFns = []

export { render, staticRenderFns }